import React from "react";

const LockedByOthersIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="61.524"
      height="45.909"
      viewBox="0 0 61.524 45.909"
    >
      <g id="db88" transform="translate(-150.761 -207.879)">
        <path
          id="Path_1779"
          data-name="Path 1779"
          d="M416.987,266.13a5.359,5.359,0,0,0-5.372,5.372v1.812a16.149,16.149,0,0,0-1.877.712,1.015,1.015,0,0,0-.582.906v9a1,1,0,0,0,.971.971h13.721a1,1,0,0,0,.971-.971v-9a.976.976,0,0,0-.582-.906c-.647-.259-1.229-.518-1.877-.712V271.5a5.359,5.359,0,0,0-5.371-5.372Zm1.488,15.145a.428.428,0,0,1-.065.388c-.13.065-.194.13-.324.13h-2.071a.5.5,0,0,1-.324-.129.428.428,0,0,1-.065-.388l.647-2.524a1.578,1.578,0,0,1-.906-1.488,1.683,1.683,0,1,1,3.365,0,1.691,1.691,0,0,1-.906,1.488Zm1.488-8.543a17.992,17.992,0,0,0-5.89,0V271.5a2.977,2.977,0,0,1,5.954,0v1.229Z"
          transform="translate(-223.081 -50.29)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1780"
          data-name="Path 1780"
          d="M367.374,207.88h-33.2a1.74,1.74,0,0,0-1.747,1.747v11.844l.841.906,2.718.388v-11.39h29.707V239.14H335.92v-4.013h-.129a3.989,3.989,0,0,1-.841-.065l-2.524-.324v6.148a1.74,1.74,0,0,0,1.747,1.747h33.2a1.74,1.74,0,0,0,1.747-1.747v-31.26a1.74,1.74,0,0,0-1.748-1.748Z"
          transform="translate(-156.837 -0.001)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1781"
          data-name="Path 1781"
          d="M174.359,306.239l4.272.582a2.281,2.281,0,1,0,.517-4.531l-4.142-.582a1.458,1.458,0,0,1-.906-.518l-3.56-3.947a5.3,5.3,0,0,0-3.883-1.748h-5.89a5.514,5.514,0,0,0-4.207,1.942,27.31,27.31,0,0,0-5.631,10.55l-.065.194a2.317,2.317,0,0,0,1.1,2.718,3.409,3.409,0,0,0,1.1.258,2.273,2.273,0,0,0,2.2-1.683l.065-.324a24.489,24.489,0,0,1,3.172-6.86l-.065,7.766-1.488,16.763a2.338,2.338,0,0,0,1.683,2.524,2.234,2.234,0,0,0,2.847-2.006l1.359-15.663a.984.984,0,0,1,.971-.906.94.94,0,0,1,.971.906l1.359,15.663a2.307,2.307,0,0,0,2.265,2.071,3.254,3.254,0,0,0,.777-.129,2.273,2.273,0,0,0,1.488-2.459l-1.488-16.827.064-7.314,1.424,1.618a6.24,6.24,0,0,0,3.689,1.942Z"
          transform="translate(0 -75.643)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1782"
          data-name="Path 1782"
          d="M219.867,212.927a5.048,5.048,0,1,1-5.048-5.048,5.048,5.048,0,0,1,5.048,5.048"
          transform="translate(-50.945)"
          fill={fill ? fill : "#ff7eb5"}
        />
      </g>
    </svg>
  );
};

export default LockedByOthersIcon;
